function guaranteeCardsReducer(state = { cardsStatus: '', activeUnusedCards:[] }, action) {
    switch (action.type) {
        case "GET_CARD_STATUS":
            return {
                ...state,
                cardsStatus: action.data
            };
            case "GET_ACTIVE_UNUSED_CARDS":
                return {
                  ...state,
                  activeUnusedCards: action.data
                }            
            default:
                return state;
    }

}
export default guaranteeCardsReducer;